var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen }
    },
    [
      _vm.isNavigationInitialized
        ? _c(
            "ul",
            { staticClass: "breadcrumb mobile-navigation__breadcrumb" },
            [
              _c(
                "li",
                {
                  staticClass: "btn-close",
                  on: {
                    click: function($event) {
                      return _vm.closeNavigation()
                    }
                  }
                },
                [
                  _c("svg", { attrs: { width: "27", height: "26" } }, [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#svg_close",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.$store.state.navigation.currentCategory &&
              _vm.$store.state.navigation.currentCategory.details
                ? _c("li", { staticClass: "breadcrumb-item" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$store.state.navigation.currentCategory.details[0]
                            .name
                        ) +
                        "\n            "
                    )
                  ])
                : _c("li", { staticClass: "breadcrumb-item" }, [
                    _vm._v("\n                Navigation\n            ")
                  ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNavigationInitialized
        ? _c(
            "ul",
            { staticClass: "mobile-navigation__wrapper" },
            _vm._l(_vm.$store.state.navigation.tree, function(item) {
              return _c("li", { staticClass: "mobile-navigation__navtree" }, [
                item.children && item.children.length
                  ? _c(
                      "a",
                      {
                        staticClass: "mobile-navigation__link",
                        class: {
                          active:
                            (_vm.$store.state.navigation.currentCategory !=
                              null &&
                              _vm.$store.state.navigation.currentCategory.id ==
                                item.id) ||
                            (_vm.$store.state.navigation.currentCategory !=
                              null &&
                              _vm.$store.state.navigation.currentCategory
                                .parentCategoryId == item.id) ||
                            _vm.openCategories.includes(item.id)
                        },
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.toggleChilds(item.id)
                          }
                        }
                      },
                      [
                        _vm.icon1CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon1))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon2CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon2))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon3CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon3))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon4CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon4))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon5CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon5))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon6CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon6))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon7CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon7))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon8CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon8))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon9CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon9))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon10CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon10))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon11CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon11))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon12CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon12))
                              }
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.details[0].name) +
                            "\n                "
                        )
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "mobile-navigation__link",
                        class: {
                          active:
                            (_vm.$store.state.navigation.currentCategory !=
                              null &&
                              _vm.$store.state.navigation.currentCategory.id ==
                                item.id) ||
                            (_vm.$store.state.navigation.currentCategory !=
                              null &&
                              _vm.$store.state.navigation.currentCategory
                                .parentCategoryId == item.id) ||
                            _vm.openCategories.includes(item.id)
                        },
                        attrs: {
                          href: _vm.getRelativeUrl(item.details[0].nameUrl)
                        }
                      },
                      [
                        _vm.icon1CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon1))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon2CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon2))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon3CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon3))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon4CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon4))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon5CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon5))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon6CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon6))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon7CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon7))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon8CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon8))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon9CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon9))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon10CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon10))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon11CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon11))
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.icon12CatId === item.id
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(JSON.parse(_vm.icon12))
                              }
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.details[0].name) +
                            "\n                "
                        )
                      ]
                    ),
                _vm._v(" "),
                item.children && item.children.length
                  ? _c(
                      "span",
                      {
                        staticClass: "mobile-navigation__open-sub",
                        on: {
                          click: function($event) {
                            return _vm.toggleChilds(item.id)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa no-dia",
                          class: {
                            "fa-chevron-down": _vm.openCategories.includes(
                              item.id
                            ),
                            "fa-chevron-right": !_vm.openCategories.includes(
                              item.id
                            )
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.children && item.children.length
                  ? _c(
                      "ul",
                      {
                        staticClass: "mobile-navigation__child-list",
                        class: {
                          "is-open": _vm.openCategories.includes(item.id)
                        }
                      },
                      [
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "mobile-navigation__link mobile-navigation__link--bold",
                              attrs: {
                                href: _vm.getRelativeUrl(
                                  item.details[0].nameUrl
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Weberbuero::Template.mobileNavShowAll"
                                  )
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(item.children, function(child) {
                          return _c(
                            "li",
                            {
                              class: {
                                "is-open--li":
                                  (_vm.$store.state.navigation
                                    .currentCategory != null &&
                                    _vm.$store.state.navigation.currentCategory
                                      .id == child.id) ||
                                  (_vm.$store.state.navigation
                                    .currentCategory != null &&
                                    _vm.$store.state.navigation.currentCategory
                                      .parentCategoryId == child.id) ||
                                  _vm.openCategories.includes(child.id)
                              }
                            },
                            [
                              child.children && child.children.length
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "mobile-navigation__link",
                                      class: {
                                        active:
                                          (_vm.$store.state.navigation
                                            .currentCategory != null &&
                                            _vm.$store.state.navigation
                                              .currentCategory.id ==
                                              child.id) ||
                                          (_vm.$store.state.navigation
                                            .currentCategory != null &&
                                            _vm.$store.state.navigation
                                              .currentCategory
                                              .parentCategoryId == child.id)
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleChilds(child.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\n                            " +
                                          _vm._s(child.details[0].name) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                : _c(
                                    "a",
                                    {
                                      staticClass: "mobile-navigation__link",
                                      class: {
                                        active:
                                          (_vm.$store.state.navigation
                                            .currentCategory != null &&
                                            _vm.$store.state.navigation
                                              .currentCategory.id ==
                                              child.id) ||
                                          (_vm.$store.state.navigation
                                            .currentCategory != null &&
                                            _vm.$store.state.navigation
                                              .currentCategory
                                              .parentCategoryId == child.id)
                                      },
                                      attrs: {
                                        href: _vm.getRelativeUrl(
                                          item.details[0].nameUrl,
                                          child.details[0].nameUrl
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\n                            " +
                                          _vm._s(child.details[0].name) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              child.children && child.children.length
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "mobile-navigation__open-sub",
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleChilds(child.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa no-dia",
                                        class: {
                                          "fa-chevron-down": _vm.openCategories.includes(
                                            child.id
                                          ),
                                          "fa-chevron-right": !_vm.openCategories.includes(
                                            child.id
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              child.children && child.children.length
                                ? _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "mobile-navigation__childChild-list",
                                      class: {
                                        "is-open": _vm.openCategories.includes(
                                          child.id
                                        )
                                      }
                                    },
                                    [
                                      _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "mobile-navigation__link mobile-navigation__link--bold",
                                            attrs: {
                                              href: _vm.getRelativeUrl(
                                                item.details[0].nameUrl,
                                                child.details[0].nameUrl
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.mobileNavShowAll"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(child.children, function(
                                        childChild
                                      ) {
                                        return _c("li", [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "mobile-navigation__link",
                                              class: {
                                                active:
                                                  _vm.$store.state.navigation
                                                    .currentCategory != null &&
                                                  _vm.$store.state.navigation
                                                    .currentCategory.id ==
                                                    childChild.id
                                              },
                                              attrs: {
                                                href: _vm.getRelativeUrl(
                                                  item.details[0].nameUrl,
                                                  child.details[0].nameUrl,
                                                  childChild.details[0].nameUrl
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  childChild.details[0].name
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-nav__contact--entries" }, [
        _c("div", { staticClass: "mobile-nav__contact--entry phone" }, [
          _c("svg", { attrs: { width: "17", height: "17" } }, [
            _c("use", {
              attrs: {
                "xlink:href": "#svg_phone",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            })
          ]),
          _c("a", { attrs: { href: "tel:+498709927788" } }, [
            _vm._v("+49 (0) 8709 / 927788")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-nav__contact--entry" }, [
          _c("svg", [
            _c("use", {
              attrs: {
                "xlink:href": "#svg_mail",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            })
          ]),
          _c("a", { attrs: { href: "mailto:info@weberbuero.de" } }, [
            _vm._v("info@weberbuero.de")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-nav__contact--entry" }, [
          _c("svg", [
            _c("use", {
              attrs: {
                "xlink:href": "#svg_form",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            })
          ]),
          _c(
            "a",
            {
              attrs: {
                href: "https://weberbuero.zendesk.com/hc/de/requests/new"
              }
            },
            [
              _vm._v(
                _vm._s(_vm.$translate("Weberbuero::Template.footerContactForm"))
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }